import { Component, Input, OnInit } from '@angular/core';
import { MaintenanceService } from '../maintenance/maintenanceService';
import { Maintenance } from '../maintenance/maintenance';
import { Client } from '../client/client';
import { User } from '../user/user';
import { Machine } from '../machine/machine';
import { DatePipe } from '@angular/common';
import { Authenticate } from '../authenticate/authenticate';
import { ActivatedRoute, Router } from '@angular/router';
import { MachineService } from '../machine/machineService';
import { HighlightSpanKind } from 'typescript';



@Component({
  selector: 'app-maintenancelistview',
  templateUrl: './maintenancelistview.component.html',
  styleUrls: ['../app.component.less', '../machine/machine.component.less']
})

export class MaintenancelistviewComponent implements OnInit {


  @Input() inMachine: number;

  public maintenances: Maintenance[];
  p: Number = 1;
  count: Number = 5;
  public _machine: Machine;
  private _user: User;
  auth: Authenticate;
  private jwt: string;
  currentuser: User;
  currentclient: Client;
  private userrole: string;
  querycriteria: string;
  searchquery: string;
  public _machines: Machine[];
  _selectedmachineid = 0;
  constructor(private maintenanceservice: MaintenanceService,
    private activateroute: ActivatedRoute,
    private machineservice: MachineService) {
  }

  //---------------------------------------------------------------------------
  // ON INIT FUNCTION / LOADS RELEVANT MAINTENANCE REPORTS
  //---------------------------------------------------------------------------

  ngOnInit(): void {

    if (this.inMachine) {
      this.maintenanceservice.getMaintenacneGqlByMachineId(this.inMachine).subscribe(resp => 
        {
          this.maintenances = resp.reverse()
          this.machineservice.getMachines().subscribe(resp => {
            this._machines = resp;
          });

    });

}
    else {
      try {
        this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
        this.jwt = this.auth.jwt;
        let role = this.auth.user.role.name;
        this.currentuser = this.auth.user;
      } catch { this.currentuser = null; }
      this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
      this.jwt = this.auth.jwt;
      let role = this.auth.user.role.name;
      this.userrole = role;
      this.currentclient = this.currentuser.client;

      if (role == "Authenticated" || this.userrole == "Administrator") {
        this.maintenanceservice.getMaintenances().subscribe(resp => {
          this.maintenances = resp.reverse();
        });
        this.machineservice.getMachines().subscribe(resp => {
          this._machines = resp;
        });
      }
      else {
        if (role = "clientsrole") {

          this.maintenanceservice.getClientMaintenance(this.currentclient.id).subscribe(resp => {
            this.maintenances = resp;
          });
          this.machineservice.getClientMachines(this.currentclient.id).subscribe(resp => {
            this._machines = resp;
          })
        }
      }
    }
  }



  //---------------------------------------------------------------------------
  // Search Function with using variable criteria
  //---------------------------------------------------------------------------

  search(shortname) {
    if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
      this.maintenanceservice.getMaintenanceByCriteriaAdmin(this.querycriteria, shortname, this.jwt).subscribe(resp => this.maintenances = resp);
    } else {
      this.maintenanceservice.getMaintenanceByCriteria(this.querycriteria, shortname, this.currentuser.client.id, this.jwt).subscribe(resp => {
        this.maintenances = resp;

      });
    }
    this.p = 1;
  }

  //---------------------------------------------------------------------------
  // Search Function with by Machine ID
  //---------------------------------------------------------------------------

  searchByMachine(mId: number) {
    this.maintenanceservice.getMaintenacneGqlByMachineId(mId).subscribe(resp => {
      this.maintenances = resp;
    });
  }
}
